import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gh-dialog" }
const _hoisted_2 = { class: "dialog-header" }
const _hoisted_3 = {
  key: 0,
  class: "dialog-title"
}
const _hoisted_4 = { class: "dialog-body" }
const _hoisted_5 = {
  key: 0,
  class: "dialog-message"
}

import { computed, useSlots } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Dialog',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    default: ''
  },
  width: {
    type: String,
    default: '420px'
  },
  showConfirm: {
    type: Boolean,
    default: true
  },
  showCancel: {
    type: Boolean,
    default: false
  },
  confirmText: {
    type: String,
    default: '确定'
  },
  cancelText: {
    type: String,
    default: '取消'
  },
  closeOnClickModal: {
    type: Boolean,
    default: true
  },
  closeOnPressEscape: {
    type: Boolean,
    default: true
  },
  showClose: {
    type: Boolean,
    default: false
  },
  center: {
    type: Boolean,
    default: true
  },
  destroyOnClose: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'close', 'confirm', 'cancel'],
  setup(__props, { emit: __emit }) {

const slots = useSlots()

const props = __props

const emit = __emit

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val)
  }
})

const handleClose = () => {
  emit('close')
  emit('update:modelValue', false)
}

const handleConfirm = () => {
  emit('confirm')
}

const handleCancel = () => {
  emit('cancel')
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      width: __props.width,
      "close-on-click-modal": __props.closeOnClickModal,
      "close-on-press-escape": __props.closeOnPressEscape,
      "show-close": __props.showClose,
      center: __props.center,
      "destroy-on-close": __props.destroyOnClose,
      onClose: handleClose
    }, _createSlots({
      footer: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["dialog-footer", { 'single-button': __props.showConfirm && !__props.showCancel }])
        }, [
          (__props.showCancel)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "cancel-btn",
                onClick: handleCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.cancelText), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.showConfirm)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                class: _normalizeClass(["confirm-btn", { 'full-width': __props.showConfirm && !__props.showCancel }]),
                onClick: handleConfirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.confirmText), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (__props.message)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.message), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 2
    }, [
      (__props.title || _unref(slots).header)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  (__props.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.title), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "width", "close-on-click-modal", "close-on-press-escape", "show-close", "center", "destroy-on-close"])
  ]))
}
}

})